export default {"src":"/_next/static/media/chatBubbleWithQuestionMark_24.7d13710b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};